import { Module } from 'vuex';
import { IRootState } from '@/store';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { state, ITakeTeilnehmerState } from './state';

export const NAME = 'praxisgruppeAdministration';
export const store: Module<ITakeTeilnehmerState, IRootState> = {
    actions,
    getters,
    mutations,
    namespaced: true,
    state
};

export default store;
